import { render } from "./ModalCopySakuhin.vue?vue&type=template&id=2c5049be&scoped=true"
import script from "./ModalCopySakuhin.vue?vue&type=script&lang=js"
export * from "./ModalCopySakuhin.vue?vue&type=script&lang=js"

import "./ModalCopySakuhin.vue?vue&type=style&index=0&id=2c5049be&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5049be"]])

export default __exports__